var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('Banner',{attrs:{"banner":_vm.banner}}),_c('div',{staticClass:"ab_bt"},[_c('TypeMenu',{staticClass:"aboutmenu",attrs:{"id":"aboutmenu","menu":_vm.type}}),_c('CompanyProfile',{ref:"about1"}),_c('Organization',{ref:"about2"}),_c('Companyculture',{ref:"about3"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }